module.exports = __webpack_public_path__ + "static/media/green-dot.b8ae76b1.png";